const translations = {
  fr: {
    // Navbar
    nav_home: "Accueil",
    nav_expertise: "Expertises",
    nav_software: "Logiciels",
    nav_news: "Actualités",
    nav_contact: "Contact",
    // Hero
    loading: "Chargement...",
    // Expertise
    expertise_label: "Notre Expertise",
    expertise_title: "25+ ans d'expérience",
    expertise_subtitle: "Une connaissance approfondie des secteurs GMS et Agroalimentaire",
    gms_title: "GMS",
    gms_subtitle: "Grande et Moyenne Surface",
    gms_desc: "Solutions dédiées à la grande distribution : gestion des stocks, optimisation des linéaires, analyse des ventes et fidélisation client.",
    gms_f1_title: "Gestion des ventes",
    gms_f1_desc: "Optimisation des performances commerciales",
    gms_f2_title: "Analytics avancés",
    gms_f2_desc: "Analyse prédictive et tableaux de bord",
    gms_f3_title: "Relation client",
    gms_f3_desc: "Fidélisation et CRM intégré",
    agro_title: "Agroalimentaire",
    agro_subtitle: "Industrie & Production",
    agro_desc: "Accompagnement digital des acteurs de l'agroalimentaire : traçabilité, conformité réglementaire, gestion de la qualité et planification.",
    agro_f1_title: "Traçabilité",
    agro_f1_desc: "Suivi complet de la chaîne de production",
    agro_f2_title: "Conformité",
    agro_f2_desc: "Respect des normes réglementaires",
    agro_f3_title: "Qualité",
    agro_f3_desc: "Certification et contrôle qualité",
    // Software
    software_label: "Nos Solutions",
    software_title: "Logiciels & Technologies",
    software_subtitle: "Des solutions sur mesure développées avec les technologies les plus performantes",
    software_more: "En savoir plus",
    // News
    news_label: "Actualités",
    news_title: "Dernières Nouvelles",
    news_subtitle: "Restez informé des dernières innovations et événements SCIAD",
    news_read_more: "Lire la suite",
    // Contact
    newsletter_label: "Newsletter",
    newsletter_title: "Restez Informé",
    newsletter_subtitle: "Recevez nos dernières actualités et innovations directement dans votre boîte mail.",
    newsletter_placeholder: "Votre adresse email",
    newsletter_submit: "S'abonner",
    newsletter_success: "Inscription réussie !",
    contact_label: "Contact",
    contact_title: "Parlons de Votre Projet",
    contact_name: "Votre nom",
    contact_email: "Votre email",
    contact_subject: "Sujet",
    contact_message: "Votre message",
    contact_submit: "Envoyer le Message",
    contact_sending: "Envoi...",
    contact_success_title: "Message Envoyé !",
    contact_success_msg: "Nous vous répondrons dans les plus brefs délais.",
    contact_error: "Une erreur est survenue. Veuillez réessayer.",
    contact_coords: "Nos Coordonnées",
    // Footer
    footer_copyright: "SCIAD - Un client, un projet. Tous droits réservés.",
    footer_legal: "Mentions légales",
    footer_privacy: "Politique de confidentialité",
    footer_admin: "Espace Admin",
    // Demo page
    demo_label: "Démonstration gratuite",
    demo_title: "Demandez une démo",
    demo_subtitle: "Découvrez comment nos solutions peuvent transformer votre activité. Remplissez le formulaire ci-dessous et notre équipe vous contactera rapidement.",
    demo_name: "Nom complet",
    demo_company: "Entreprise",
    demo_email: "Email professionnel",
    demo_phone: "Téléphone",
    demo_software_label: "Solution qui vous intéresse",
    demo_software_placeholder: "Sélectionnez une solution",
    demo_software_multi: "Plusieurs solutions",
    demo_software_unknown: "Je ne sais pas encore",
    demo_message: "Votre message (optionnel)",
    demo_message_placeholder: "Décrivez votre projet ou vos besoins spécifiques...",
    demo_submit: "Demander ma démonstration gratuite",
    demo_submitting: "Envoi en cours...",
    demo_success_title: "Demande envoyée !",
    demo_success_msg: "Merci pour votre intérêt. Notre équipe vous contactera dans les plus brefs délais pour organiser votre démonstration personnalisée.",
    demo_back: "Retour à l'accueil",
    demo_form_consent: "En soumettant ce formulaire, vous acceptez d'être contacté par notre équipe commerciale.",
    demo_sidebar_title: "Ce que vous obtiendrez",
    demo_sidebar_items: [
      "Démonstration personnalisée de 30-45 min",
      "Présentation adaptée à votre secteur",
      "Réponses à toutes vos questions",
      "Proposition commerciale sur mesure",
      "Sans engagement",
    ],
    demo_sidebar_exp: "25+ ans d'expérience",
    demo_sidebar_exp_desc: "Nos experts vous accompagnent dans la transformation digitale de votre activité GMS ou Agroalimentaire.",
    // Cookie consent
    cookie_text: "Ce site utilise des cookies pour améliorer votre expérience et analyser le trafic.",
    cookie_accept: "Accepter tout",
    cookie_reject: "Refuser",
    cookie_more: "En savoir plus",
    // Maintenance
    maintenance_title: "Site en maintenance",
    maintenance_msg: "Nous effectuons actuellement une mise à jour. Nous serons de retour très bientôt.",
  },
  en: {
    nav_home: "Home",
    nav_expertise: "Expertise",
    nav_software: "Software",
    nav_news: "News",
    nav_contact: "Contact",
    loading: "Loading...",
    expertise_label: "Our Expertise",
    expertise_title: "25+ years of experience",
    expertise_subtitle: "In-depth knowledge of the Retail and Agri-food sectors",
    gms_title: "Retail",
    gms_subtitle: "Large & Medium Retailers",
    gms_desc: "Solutions for retail: inventory management, shelf optimization, sales analysis and customer loyalty.",
    gms_f1_title: "Sales management",
    gms_f1_desc: "Commercial performance optimization",
    gms_f2_title: "Advanced analytics",
    gms_f2_desc: "Predictive analysis and dashboards",
    gms_f3_title: "Customer relations",
    gms_f3_desc: "Loyalty and integrated CRM",
    agro_title: "Agri-food",
    agro_subtitle: "Industry & Production",
    agro_desc: "Digital support for agri-food stakeholders: traceability, regulatory compliance, quality management and planning.",
    agro_f1_title: "Traceability",
    agro_f1_desc: "Full production chain tracking",
    agro_f2_title: "Compliance",
    agro_f2_desc: "Regulatory standards adherence",
    agro_f3_title: "Quality",
    agro_f3_desc: "Certification and quality control",
    software_label: "Our Solutions",
    software_title: "Software & Technologies",
    software_subtitle: "Custom solutions built with the most powerful technologies",
    software_more: "Learn more",
    news_label: "News",
    news_title: "Latest News",
    news_subtitle: "Stay informed about the latest SCIAD innovations and events",
    news_read_more: "Read more",
    newsletter_label: "Newsletter",
    newsletter_title: "Stay Informed",
    newsletter_subtitle: "Receive our latest news and innovations directly in your inbox.",
    newsletter_placeholder: "Your email address",
    newsletter_submit: "Subscribe",
    newsletter_success: "Successfully subscribed!",
    contact_label: "Contact",
    contact_title: "Let's Talk About Your Project",
    contact_name: "Your name",
    contact_email: "Your email",
    contact_subject: "Subject",
    contact_message: "Your message",
    contact_submit: "Send Message",
    contact_sending: "Sending...",
    contact_success_title: "Message Sent!",
    contact_success_msg: "We will get back to you as soon as possible.",
    contact_error: "An error occurred. Please try again.",
    contact_coords: "Our Contact Info",
    footer_copyright: "SCIAD - One client, one project. All rights reserved.",
    footer_legal: "Legal notice",
    footer_privacy: "Privacy policy",
    footer_admin: "Admin Area",
    demo_label: "Free demo",
    demo_title: "Request a demo",
    demo_subtitle: "Discover how our solutions can transform your business. Fill out the form below and our team will contact you shortly.",
    demo_name: "Full name",
    demo_company: "Company",
    demo_email: "Professional email",
    demo_phone: "Phone",
    demo_software_label: "Solution of interest",
    demo_software_placeholder: "Select a solution",
    demo_software_multi: "Multiple solutions",
    demo_software_unknown: "I don't know yet",
    demo_message: "Your message (optional)",
    demo_message_placeholder: "Describe your project or specific needs...",
    demo_submit: "Request my free demo",
    demo_submitting: "Sending...",
    demo_success_title: "Request sent!",
    demo_success_msg: "Thank you for your interest. Our team will contact you shortly to schedule your personalized demo.",
    demo_back: "Back to home",
    demo_form_consent: "By submitting this form, you agree to be contacted by our sales team.",
    demo_sidebar_title: "What you'll get",
    demo_sidebar_items: [
      "Personalized 30-45 min demo",
      "Presentation tailored to your industry",
      "All your questions answered",
      "Custom commercial proposal",
      "No commitment",
    ],
    demo_sidebar_exp: "25+ years of experience",
    demo_sidebar_exp_desc: "Our experts guide you through the digital transformation of your Retail or Agri-food business.",
    cookie_text: "This site uses cookies to improve your experience and analyze traffic.",
    cookie_accept: "Accept all",
    cookie_reject: "Reject",
    cookie_more: "Learn more",
    maintenance_title: "Site under maintenance",
    maintenance_msg: "We are currently updating. We will be back very soon.",
  },
};

export default translations;
